module.exports = __webpack_public_path__ + "img/Avatar2.dd03d77c.png";